import * as swcHelpers from '@swc/helpers';
import isEmpty from 'lodash/isEmpty';

/** @deprecated use the new GQL hook use-opt-ins.ts */ const createOptInsUpdate = (optIns = {})=>{
    if (isEmpty(optIns)) {
        return undefined;
    }
    return Object.keys(optIns).reduce((m, optInName)=>swcHelpers.objectSpread({}, m, {
            [optInName]: {
                value: optIns[optInName].checked,
                uiType: 'checkbox',
                literalText: optIns[optInName].label
            }
        })
    , {});
};

export { createOptInsUpdate };
//# sourceMappingURL=create-opt-in-updates.js.map
